// extracted by mini-css-extract-plugin
export default {"totals":"qoC5L","total":"g60qC","totalText":"Lc4as","totalValue":"vd7an"};